import { render, staticRenderFns } from "./consignor.vue?vue&type=template&id=5e7a2d12&scoped=true&"
import script from "./consignor.vue?vue&type=script&lang=js&"
export * from "./consignor.vue?vue&type=script&lang=js&"
import style0 from "./consignor.vue?vue&type=style&index=0&id=5e7a2d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a2d12",
  null
  
)

export default component.exports